<template>
    <div class="bg-white py-5">
    <div class="container mb-5">
      <h1 class="py-4">
        If you invest in the current round and we reach unicorn status ($1
        billion valuation) what is your return?
      </h1>
      <div class="row">
        <div class="col">
          <div class="border rounded p-5 bg-light">
            <div class="fs-4 mb-4">
              $10,000 investment would return $500,000 upon reaching $1 billion
              valuation
            </div>
            <div class="d-flex align-items-center">
              <div class="input-group w-50">
                <span class="input-group-text fs-2">$</span>
                <input
                  type="number"
                  class="form-control fs-2"
                  placeholder="10000"
                  v-model="investment"
                />
              </div>

              <div class="text-center w-50 display-6">{{ calculation }}</div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="d-flex h-100 align-items-center p-5">
            <div class="fs-3">
              <div class="mb-3"><strong>Calculator formula</strong></div>
              <div>Investment = Inv</div>
              <div>Return = 50 &times; Inv</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      investment: ""
    };
  },
  computed: {
    calculation() {
      if (this.investment === "") {
        return "$500000";
      } else {
        return `$${this.investment * 50}`;
      }
    }
  }
}
</script>